import React from 'react';
import { Button, Card, Col, Row, Tag, Typography, Divider, Space } from 'antd';
import {
  CloudServerOutlined, EditOutlined, SwapOutlined, RobotOutlined, FolderOpenOutlined,
  SafetyOutlined, RocketOutlined, ShoppingCartOutlined, FileTextOutlined, PictureOutlined,
  CheckCircleFilled, GiftOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const FEATURES = [
  { icon: <EditOutlined />, title: '在线编辑', desc: 'Word/Excel/PPT/PDF/文本/图片 在线编辑，实时自动保存，保留历史版本' },
  { icon: <SwapOutlined />, title: '格式转换', desc: 'PDF↔Office/HTML/RTF/TXT 互转，浏览器直接转换' },
  { icon: <RobotOutlined />, title: 'AI 办公', desc: '写作/润色/翻译/总结/PPT 生成/知识库问答，主流大模型自由接入' },
  { icon: <FolderOpenOutlined />, title: '1000 套模板', desc: '30 行业 PPT 模板库，首个行业限免，其余 ¥9.9/行业' },
  { icon: <PictureOutlined />, title: '图片工具', desc: '高清放大/裁剪/水印/滤镜/格式转换，一键另存' },
  { icon: <SafetyOutlined />, title: '数据自主可控', desc: '私有部署，数据存您自己的服务器，不收费不限速' },
];

const STEPS = [
  { t: '1. 访问云盘', d: '打开 pan.aibak.site' },
  { t: '2. 登录/注册', d: '云盘账号 或 www.aibak.site 官网账号一键登录' },
  { t: '3. 开始使用', d: '上传文件→在线编辑/转换→AI 办公→模板一键复制' },
];

export default function CloudDrivePage() {
  const nav = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(180deg,#eef2ff 0%,#f8fafc 40%,#ffffff 100%)' }}>
      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '72px 24px 40px' }}>
        <Tag color="purple" style={{ marginBottom: 16 }}>🎉 限时全功能免费</Tag>
        <Title style={{ fontSize: 44, marginBottom: 8, background: 'linear-gradient(90deg,#4f46e5,#7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          AIbak 云盘 · 私有云盘 + 在线办公
        </Title>
        <Paragraph style={{ fontSize: 18, color: '#475569', maxWidth: 760, margin: '0 auto' }}>
          专业在线办公：文件存储 · 在线编辑 · 格式转换 · AI 办公 · 1000 套行业模板
          —— 数据在您自己服务器，不收费、不限速、无广告。
        </Paragraph>
        <Space size={16} style={{ marginTop: 28 }} wrap>
          <Button type="primary" size="large" icon={<RocketOutlined />} style={{ borderRadius: 999, padding: '0 28px' }}
            onClick={() => window.open('https://pan.aibak.site', '_blank')}>立即使用云盘</Button>
          <Button size="large" icon={<ShoppingCartOutlined />} style={{ borderRadius: 999, padding: '0 28px' }}
            onClick={() => window.open('https://pan.aibak.site', '_blank')}>免费体验模板</Button>
          <Button size="large" icon={<GiftOutlined />} style={{ borderRadius: 999, padding: '0 28px' }}
            onClick={() => nav('/register')}>注册送积分</Button>
        </Space>
      </div>

      {/* 功能 */}
      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '24px 24px 48px' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>核心功能</Title>
        <Row gutter={[20, 20]}>
          {FEATURES.map(f => (
            <Col xs={24} sm={12} md={8} key={f.title}>
              <Card hoverable style={{ height: '100%', borderRadius: 16 }}>
                <div style={{ fontSize: 30, color: '#6366f1', marginBottom: 10 }}>{f.icon}</div>
                <Text strong style={{ fontSize: 16 }}>{f.title}</Text>
                <Paragraph type="secondary" style={{ marginTop: 6, minHeight: 44 }}>{f.desc}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* 三步上手 */}
      <div style={{ background: '#fff', padding: '48px 24px' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>三步上手</Title>
          <Row gutter={24}>
            {STEPS.map((s, i) => (
              <Col span={8} key={s.t} style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 26, fontWeight: 800, color: '#6366f1' }}>{i + 1}</div>
                <Text strong style={{ fontSize: 16 }}>{s.t}</Text>
                <div><Text type="secondary">{s.d}</Text></div>
              </Col>
            ))}
          </Row>
        </div>
      </div>

      {/* 定价 */}
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '48px 24px' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: 8 }}>价格 · 限时免费</Title>
        <Paragraph style={{ textAlign: 'center', color: '#64748b' }}>
          全功能限时免费：在线编辑 / 转换 / AI 办公 / 模板 · 首个行业模板免费，其余 ¥9.9/行业
        </Paragraph>
        <Row gutter={24} style={{ marginTop: 24 }} justify="center">
          <Col xs={24} md={10}>
            <Card style={{ borderRadius: 16, border: '2px solid #6366f1', textAlign: 'center' }}>
              <Tag color="green">限时</Tag>
              <Title level={3} style={{ margin: '12px 0 4px' }}>全功能免费</Title>
              <div style={{ fontSize: 34, fontWeight: 800, color: '#6366f1' }}>¥0</div>
              <Paragraph type="secondary">在线编辑 · 格式转换 · AI 办公 · 存储</Paragraph>
              <Button type="primary" block style={{ borderRadius: 999 }} onClick={() => window.open('https://pan.aibak.site', '_blank')}>立即使用</Button>
            </Card>
          </Col>
          <Col xs={24} md={10}>
            <Card style={{ borderRadius: 16, textAlign: 'center' }}>
              <Tag color="orange">付费增值</Tag>
              <Title level={3} style={{ margin: '12px 0 4px' }}>行业模板库</Title>
              <div style={{ fontSize: 34, fontWeight: 800, color: '#f59e0b' }}>¥9.9<span style={{ fontSize: 14, color: '#94a3b8' }}>/行业</span></div>
              <Paragraph type="secondary">30 行业 1000 套 · 支持官网积分抵扣</Paragraph>
              <Button block style={{ borderRadius: 999 }} onClick={() => window.open('https://pan.aibak.site', '_blank')}>浏览模板</Button>
            </Card>
          </Col>
        </Row>
      </div>

      <Divider />
      <div style={{ textAlign: 'center', padding: '0 24px 48px', color: '#94a3b8' }}>
        AIbak 云盘 · NexMind by AIbak · 数据自主可控 · <a href="https://pan.aibak.site" target="_blank" rel="noreferrer">pan.aibak.site</a>
      </div>
    </div>
  );
}
